import React, { useEffect, useState, useContext } from "react";
import "./JobBankLandingPage.css";
import { useNavigate } from "react-router-dom";
import JobBankScreen1 from "./assets/JobBank/JobBankScreen1.png";
import JobBankScreen2 from "./assets/JobBank/JobBankScreen2.png";
import JobBankScreen3 from "./assets/JobBank/JobBankScreen3.png";
import JobBankScreen4 from "./assets/JobBank/JobBankScreen4.png";
import JobBankScreen5 from "./assets/JobBank/JobBankScreen5.png";
import { useAuth } from "./AuthContext";
import { TokenContext } from "./tokenContext"; // import TokenContext
import { logout } from "../utils/firebase";
import { createPortal } from "react-dom";
import GlobalNavDrawer from "./GlobalNavDrawer";
import {
  isAdmin,
  isCareerCoach,
  isEmployer,
  ACCESS_REQUEST_TYPES,
  buildAccessRequestUrl,
  useJobBankRole
} from "./jobBankRole";
import { db } from "../utils/firebase";
import {  doc, getDoc } from "firebase/firestore";
import {
  FaBriefcase,
  FaCalendarAlt,
  FaBuilding,
  FaUserTie,
  FaUsers,
  FaHandshake,
  FaChartLine,
  FaMapMarkerAlt,
  FaSignInAlt,
  FaSignOutAlt,
  FaPuzzlePiece
} from "react-icons/fa";

const backgrounds = [
  JobBankScreen1,
  JobBankScreen2,
  JobBankScreen3,
  JobBankScreen4,
  JobBankScreen5
];


const JobBankLandingPage = () => {
  const { balance, setBalance } = useContext(TokenContext);
  const [currentBackground, setCurrentBackground] = useState(0);

  const navigate = useNavigate();

  const navigateTo = (path) => {
    navigate(path);
  };

  const { currentUser } = useAuth();
  const { role } = useJobBankRole(currentUser);
  const careerCoachDestination =  (isAdmin(role) || isCareerCoach(role)) ? "/cecp": "/careercoaches";

  const isLoggedIn = !!currentUser;
  const canRequestJobBankRole = isLoggedIn &&
    !isAdmin(role) &&
    !isEmployer(role) &&
    !isCareerCoach(role);

  const handleAuthButton = async () => {
    if (isLoggedIn) {
      await logout();
      navigate("/jobbank");
    } else {
      navigate("/jobbank/login");
    }
  };

  useEffect(() => {
    let isMounted = true;

    const fetchTokens = async () => {
      if (!currentUser?.uid) return;

      const userRef = doc(db, "users", currentUser.uid);

      try {
        const userDoc = await getDoc(userRef);

        if (userDoc.exists() && isMounted) {
          setBalance(userDoc.data().tokens ?? 0);
        }
      } catch (error) {
        console.error("Error fetching token count:", error);
      }
    };

    fetchTokens();

    return () => {
      isMounted = false;
    };
  }, [currentUser, setBalance]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentBackground((prev) =>
        (prev + 1) % backgrounds.length
      );
    }, 10000);

    return () => clearInterval(timer);
  }, []);

  const goTo = (url) => {
    window.location.href = url;
  };

  return (
    <div className="jobbank-landing-page">

      {/* Background Rotator */}
      {backgrounds.map((image, index) => (
        <div
          key={index}
          className={`background-slide ${
            index === currentBackground ? "active" : ""
          }`}
          style={{
            backgroundImage: `url(${image})`
          }}
        />
      ))}

      <div className="overlay" />

      <div className="page-content">

        {/* Header */}
        <header className="hero-header">

          <h1>Community Job Bank</h1>

          <p className="powered-by">
            Powered by The iSpeakWell Project
          </p>

          <h2>
            Your Community. Your Career.
            Your Business. Your Future.
          </h2>

          <p className="subtitle">
            Connecting local talent to local opportunities.
          </p>

        </header>

        {/* Benefits Ribbon */}
        <div className="benefits-bar">

          <div>
            <FaMapMarkerAlt />
            <span>Built for Small Communities</span>
          </div>

          <div>
            <FaUsers />
            <span>
              Local Connections. Real Opportunities.
            </span>
          </div>

          <div>
            <FaChartLine />
            <span>
              Resources for Every Stage of Your Career
            </span>
          </div>

          <div>
            <FaHandshake />
            <span>
              Stronger Communities. Stronger Businesses.
            </span>
          </div>

        </div>

        {/* Main Grid */}
        <div className="portal-grid">

          {/* TOP LEFT */}
            <div
              className="portal-card coach-card"
              onClick={() => goTo(careerCoachDestination)}
            >
              <FaUserTie />

              <h3>Career Coach</h3>

              <p>
                Guidance, assessments, client
                management, coaching tools,
                and reporting.
              </p>
            </div>

          {/* CENTER */}
          <div
            className="portal-card featured"
            onClick={() => goTo("/jobbankjobs")}
          >
            <FaBriefcase />

            <h3>Job Bank</h3>

            <p>
              Search jobs, connect employers
              and job seekers, and discover
              opportunities in your community.
            </p>

            <button>
              Enter Job Bank
            </button>
          </div>

          {/* CENTER BOTTOM */}
          <div
            className="portal-card carveout-card"
            onClick={() => goTo("/jobcarveouts")}
          >
            <FaPuzzlePiece />

            <h3>Job Carve-Out</h3>

            <p>
              Customized employment pathways
              shaped around strengths, barriers,
              hours, tasks, and support needs.
            </p>

            <button>
              Explore Carve-Outs
            </button>
          </div>

          {/* TOP RIGHT */}
          <div
            className="portal-card events-card"
            onClick={() => goTo("/events")}
          >
            <FaCalendarAlt />

            <h3>Hiring Events</h3>

            <p>
              Job fairs, employer mixers,
              workshops, and community events.
            </p>
          </div>

          {/* BOTTOM LEFT */}
          <div
            className="portal-card seeker-card"
            onClick={() => goTo("/profile")}
          >
            <FaUsers />

            <h3>Job Seeker Profile</h3>

            <p>
              Build your profile, upload your
              resume, showcase certifications
              and career goals.
            </p>
          </div>

          {/* BOTTOM RIGHT */}
          <div
            className="portal-card employer-card"
            onClick={() => goTo("/employers")}
          >
            <FaBuilding />

            <h3>Employer Profile</h3>

            <p>
              Post jobs, discover talent,
              manage applicants, and connect
              with coaches.
            </p>
          </div>

        </div>

        {/* Footer */}
        <footer>

          <div className="community-text">
            Proudly supporting communities like:
            <strong> Spruce Grove +55km</strong>
          </div>

          <div className="footer-links">
            {canRequestJobBankRole && (
              <>
                <button
                  onClick={() => navigateTo(
                    buildAccessRequestUrl({
                      requestedRole: ACCESS_REQUEST_TYPES.EMPLOYER_PROFILE.requestedRole,
                      requestedAccess: ACCESS_REQUEST_TYPES.EMPLOYER_PROFILE.label,
                      requestKey: ACCESS_REQUEST_TYPES.EMPLOYER_PROFILE.requestKey,
                      sourcePath: "/jobbank"
                    })
                  )}
                >
                  Request Employer Access
                </button>
                <button
                  onClick={() => navigateTo(
                    buildAccessRequestUrl({
                      requestedRole: ACCESS_REQUEST_TYPES.CAREER_COACH_PORTAL.requestedRole,
                      requestedAccess: ACCESS_REQUEST_TYPES.CAREER_COACH_PORTAL.label,
                      requestKey: ACCESS_REQUEST_TYPES.CAREER_COACH_PORTAL.requestKey,
                      sourcePath: "/jobbank"
                    })
                  )}
                >
                  Request Career Coach Access
                </button>
              </>
            )}
            {isAdmin(role) && (
              <button onClick={() => navigateTo("/accessRequests")}>
                View Access Requests
              </button>
            )}
            <button onClick={() => navigateTo("/jobbank/about")}>About Us</button>
            <button onClick={() => navigateTo("/jobbank/contact")}>Contact</button>
            <button onClick={() => navigateTo("/jobbank/help")}>Help</button>
            <button onClick={handleAuthButton}>
              {isLoggedIn ? (
                <>
                  <FaSignOutAlt style={{ marginRight: "6px" }} />
                  Sign Out
                </>
              ) : (
                <>
                  <FaSignInAlt style={{ marginRight: "6px" }} />
                  Sign In
                </>
              )}
            </button>
          </div>

        </footer>

      </div>
        {createPortal(
                      <GlobalNavDrawer
                        hideCurrent
                        links={[
                          { to: "/purchase", label: `Tokens: ${balance}`},
                          { to: "/voicebot", label: "iSpeakWell" },
                          { to: "/resumerevisor", label: "Resumes" },
                          { to: "/conversationpractice", label: "Convos" },
                          { to: "/interview-practice", label: "Interviews" },
                          { to: "/termsofservice", label: "Terms" },
                          { to: "/privacypolicy", label: "Privacy" },
                          { to: "/admin", label: "Admin" },
                          { to: "/login", label: "Logout", onClick: async () => { await logout(); } },
                        ]}
                      />,
                        document.body
                    )}
      </div>
    );
  };

export default JobBankLandingPage;